module.exports = __webpack_public_path__ + "img/memo.47aa2147.svg";